import { CurrencyTypeEnum } from '@app/interfaces/interfaces';

export const currencies = {
  [CurrencyTypeEnum.USD]: {
    text: 'USD',
    icon: '$',
  },
  [CurrencyTypeEnum.EUR]: {
    text: 'EUR',
    icon: '€',
  },
  [CurrencyTypeEnum.CHF]: {
    text: 'CHF',
    icon: 'CHF',
  },
  [CurrencyTypeEnum.BTC]: {
    text: 'BTC',
    icon: '₿',
  },
  [CurrencyTypeEnum.ETH]: {
    text: 'ETH',
    icon: 'Ξ',
  },
};
